'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-1887e1af.js');
var React = require('react');
var styled = require('styled-components');
var components_SvgIcon_index = require('../SvgIcon/index.js');
var components_Body2_index = require('../Body2/index.js');
var components_Title2_index = require('../Title2/index.js');
var constants_properties = require('../../constants/properties.js');
var checkCircleFilled = require('../../check-circle-filled-3a352a66.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StyledStep = styled__default["default"].div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 70px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 70px;\n"])));
var StepLabel = styled__default["default"](components_Title2_index["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  margin-top: 8px;\n  white-space: nowrap;\n"], ["\n  margin-top: 8px;\n  white-space: nowrap;\n"])));
var NumberedIcon = styled__default["default"].div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 50%;\n  height: 20px;\n  width: 20px;\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  background-color: ", ";\n  border-radius: 50%;\n  height: 20px;\n  width: 20px;\n  color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_a) {
    var _b = _a.theme.colors.text, interactive = _b.interactive, primary = _b.primary, active = _a.active;
    return (active ? interactive : primary);
}, function (_a) {
    var light = _a.theme.colors.text.light;
    return light;
});
var SubText = styled__default["default"](components_Body2_index["default"])(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  white-space: nowrap;\n  color: ", ";\n"], ["\n  white-space: nowrap;\n  color: ", ";\n"])), function (_a) {
    var secondary = _a.theme.colors.text.secondary;
    return secondary;
});
var CheckIcon = styled__default["default"](components_SvgIcon_index["default"]).attrs({
    icon: checkCircleFilled.SvgCheckCircleFilled,
    fill: constants_properties.SVG_ICON_COLORS.INTERACTIVE,
    size: constants_properties.SVG_ICON_SIZES.MEDIUM,
})(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject([""], [""])));
var displayIcon = function (_a) {
    var status = _a.status, number = _a.number;
    switch (status) {
        case constants_properties.STEPPER_STATUS.COMPLETED:
            return React__default["default"].createElement(CheckIcon, null);
        case constants_properties.STEPPER_STATUS.ACTIVE:
            return React__default["default"].createElement(NumberedIcon, { active: true }, number);
        case constants_properties.STEPPER_STATUS.INACTIVE:
            return React__default["default"].createElement(NumberedIcon, { active: false }, number);
        default:
            return React__default["default"].createElement(NumberedIcon, { active: true });
    }
};
var Step = function (_a) {
    var label = _a.label, className = _a.className, sub_text = _a.sub_text, number = _a.number, status = _a.status;
    return (React__default["default"].createElement(StyledStep, { className: className },
        displayIcon({ status: status, number: number }),
        React__default["default"].createElement(StepLabel, null, label),
        sub_text ? React__default["default"].createElement(SubText, null, sub_text) : null));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports["default"] = Step;
